import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { retry } from 'rxjs/operators';
import { BillyCities } from 'src/app/@interfaces/Billy/billy.interface';
import { ICities } from 'src/app/@interfaces/cities.interface';
import { ICountry } from 'src/app/@interfaces/country.interface';
import { BillyService } from 'src/app/@pages/billyService/billy.service';
import { CitiesService } from 'src/app/@pages/cities/cities.service';
import { TributaryService } from 'src/app/@pages/tributary/tributary.service';

const CITIES_RETRY_COUNT = 3;
const CITIES_RETRY_DELAY_MS = 1500;

@Injectable({
  providedIn: 'root',
})
export class CitiesFormService {
  private citiesService = inject(CitiesService);
  private billyService = inject(BillyService);
  private tributaryService = inject(TributaryService);

  setInitialCitiesFromStore() {
    const countries = ['United States', 'Argentina'];
    this.getMainCountryCities(countries);
  }

  getMainCountryCities(countries: string[]) {
    const citiesPreloaded = localStorage.getItem(countries[0]);
    if (citiesPreloaded) return;
    countries.forEach((country) => {
      this.citiesService.postCities(country).subscribe((res) => {
        localStorage.setItem(country, JSON.stringify(res.data));
      });
    });
  }

  async getCityList(country: ICountry) {
    let cityList = JSON.parse(localStorage.getItem(country.name)!);
    if (!cityList) {
      cityList = await this.getOtherCities(country.name);
    }
    return cityList;
  }

  async getOtherCities(nameCountrySelected: string): Promise<string[]> {
    const result = await firstValueFrom(
      this.citiesService
        .postCities(nameCountrySelected)
        .pipe(
          retry({ count: CITIES_RETRY_COUNT, delay: CITIES_RETRY_DELAY_MS }),
        ),
    );
    return result.data;
  }

  async getBillyCities(countrySelected: string): Promise<BillyCities> {
    return firstValueFrom(
      this.billyService
        .getCities(parseInt(countrySelected))
        .pipe(
          retry({ count: CITIES_RETRY_COUNT, delay: CITIES_RETRY_DELAY_MS }),
        ),
    );
  }

  getOwnCities(country_id?: number) {
    return new Promise<ICities[]>((resolve, reject) => {
      this.tributaryService
        .getCitiesByCompany(parseInt(country_id!.toString() ?? 44))
        .subscribe((result) => {
          resolve(result);
        });
    });
  }
}
